import { Component, OnInit, Inject, Input, DOCUMENT } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgxImageCompressService } from 'ngx-image-compress';
import { IAnnotation } from '@ebb-v2/ebb-integration';
import { base64StringToBlob } from 'blob-util';
import { AnnotationApiService, BlobApiService } from '../../data-services/index';

import { ContractorFormComponent } from '../forms/contractor-form.component';
import { DomSanitizer } from '@angular/platform-browser';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DialogViewComponent, IDialogViewData } from './dialog-view.component';
import { MatDialog } from '@angular/material/dialog';

export interface DialogUploadApplicationBidData {
  id: string;
  isImage: boolean;
  isSelected: boolean;
  useFormName: string;
  attachmentName: string;
  attachmentType: string;
  attachmentCreatedDate: string;
  attachmentUploadDate: string;
  contractorName: string;
  contractorId: string;
  ownerId: string;
  ownerIdFormatted: string;
  applicationId: string;
  uploadFileName: string;
  uploadFile: Blob;
  estimatedCost: number;
  estimatedCost2: number;
  contractorId2: string;
  bidId2: string;
  isSelected2: boolean;
  firstOrSecond: string;
  reason: string;
  reason2: string;
  reasonRequired: boolean;
  payload: string;
  payloadName: string;
  multipleBidsRequired: boolean;
  approvaltaskitemid: string;
  bidType: string;
  estimatemax:number
}

export class BidFile {
  fileId: string;
  file: any;
  fileShow: boolean;
}


@Component({
  selector: 'ebb-portal-dialog-upload-applicationbid',
  templateUrl: './dialog-upload-applicationbid.component.html',
  styleUrl: './dialog-upload-applicationbid.component.scss',
  standalone: false,
})
export class DialogUploadApplicationBidComponent implements OnInit {
  @Input('title') title = 'Upload Estimate';
  public createdDate = new Date().toLocaleDateString();

  public displayFileName = 'No file selected.';

  public fileError = false;
  public fileUploadLabel = 'BROWSE FOR FILE';
  public fileSelected: any;
  public estimatedCost: number;
  public fileLocalUrl: any;
  public displayFileUrl: any = null;
  public disableFileSave = true;
  public showRotateImage = false;
  public imageOrientation = -1;
  public rotateDegree = 90;
  public disableSubmitBid = true;
  public higherBidSelected = false;
  public bidSelected = true;
  public bidSelectedOriginal = true;
  public estimatedCost2Original;

  public filesToShow: BidFile[] = [];
  public waitForFilesToShow = 0;
  public waitForFileToUpload = -1;
  public fileId: string;
  public payloadName: string;
  public displayLink = 'false';

  public attachmentBase64 =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAABnVJREFUeJztnXuIFVUcxz+rW6tbai9J7GGi0suMirYiMCn7I7Ki7B9N6R97U1FU9JTCyigiwh70ppKC3g8rWMLcJE0JJVYpM6MEtTXNXm6Uutsfv1l27rl37b7mnDP39/vAcGfOzJlz7p3vzG/m9/vNuU3EwzhgAnAY0AJ0AV8DG4DegP0yMmQEcDfQiRzkUtMG4B7goEB9NDKgCbga+IWBD7w7/Q5cm9Q1csxQ4HXKP/Du9A7Q6r3XDYrvs6kFaAcml1i3HfgS2ALsAkYDpwGjSmzbAZwH/J1NN40saAJepviM/gI4Bxhcos4g4GxgaYl6r2HmIFfMpPgg3oscZJAz/UbgFeQyPw84Jlk3CJhbov5lfrpu1MpQYCOFB29+sq4JuBXYSfEB7gEeB/ZNtn3AWb852bdRJb4uoVcAz6aW1wInIgf4mWT93lgEXJzMrwJOSK27EngutTwcuYrEylrk0VeVb6OdwjN3RlJ+HcVn/UDTXUkd15Qscdo6pIJ9hppuq+znyzf7Abvp//K7kLN0GLCDwh/mY8SuXwosdNb9BRwI7F9if2kzkAcB9NB/RWt4jqbwy3cm5TOc8qX03xCCmCf3yjE7WbfGKZ+UqpcHAfQi9zwnl/0rZkSzhzYOd5a3Jp9nOeUdyJnRRy/wGXBuquz45LMrNQ8wMjX/J/GdXc8DBztlrcCHQBuwyXuPEnwIwL1L73PeuDeg20rUdR09Q5LPXU75Pqn5f4D3yu6dH54YoHw0IoLJiInzzqD/3yQz3IO4O0gvwnMScr9TyhGWOSEFoJl2Z/ki4KEQHTEBhOF6YLVTdgswx3dHTABh6AYuQDyZaZ5G4iLeMAGEYxMigu5UWTPwFvLo7AUTQFhWAbOQR94+DgA+ovixMRNMAOF5F7jdKRuHRERbsm7cBBAHjwAvOmWTkUBZpgE7E0Ac9ALXUBzYupziq0NdMQHEw7/AdGC9U/4gEhzLBBNAXPwKnI9ESdO8CpyaRYMmgPhYD1xCoat8CPABcGS9GzMBxMkS4CqnbBQSOBpWz4ZMAPHyEvCwUzYJyYauW+DIRzi4FhYCn6aWt4fqSCDuQN6XTOc3TEMeG2+uRwOxC2AbpfMEtNCDZEF9TmH20E3AOsRPUBNmAuJnJxIzcLOGnqQwW6oqTAD5YDNwIYWBo8HAm8CxtezYBJAfVtGfEt/HCCRwNLJkjTIwAeSL9yl+p2AsElCqKnBkAsgfjyJZxmnOTMoqDhzF/hTQqExE4v7V8hTiE2hLlc1Cngzur2RHJoAwfJLRfucB3wFvlFvBTEDjMbeSjU0AyjET4Id1wG8Z7bsFGF9t5ZAC6HGWKwlwuNu6+4qNLFO9J9L/wm3FhDQBW5zlCWXWa6I4bdrNrzfKJKQAFjvLs4Ejyqg309nuZ+CbenVKGyEFsBJYkVoejojijAG2b0aGg3nBKV8A7Kl775QQ8h6gFxktdAX9g0CNB5Yh780tQ8YBaAaOAqYir1On6QQe89BXowamUTgyxiJn/XQk/63SETZ+AsZk3/3omUjh77Kmksox+AHeRuLalYySsRg4HRGBUQMxCAAkCfI4ZODIrr1stxoZW2gqxU8RRhXE5Aj6A7gPCWa0AacAhyIjh/yIDCn7fajONSoxCaCPPcDyZDIyJhYTYATCBKCcGE3AQAQZRcszPRTm/GVOXgQwBRk0stFZANzgs0EzAcoxASgnLyagFx0jiXrPa8iLADooHA/YqBNmApRjAlCOCUA5JgDlhBCA/dljRPgQgFfXplEZZgKUYwJQjglAOSYA5eTFFQw68gH6/lXUG3kRwBQsHyATzAQoxxxByvFhAurhCLJ8gIzIyz2A5QNkhN0DKMcEoBwTgHJMAMoxASjHBKAccwQpxzKClGMmQDl58QS2Ut4gknlnB7DVZ4N5EUAbFg7OBDMByjEBKCcvJqAb+DZ0JzywtzESMyEvAlhJjX+QaJTGHEHKMUeQcuwmUDkmAOWYAJRjAlCOCUA5JgDlmACUE8ITWI0jaCwwp94diZDlFP+pVqbk5dWwMcCdddhP7CzAswDMBCjHBKCcvEQDf0CHCfjKd4N5EcBGYH7oTjQiZgKUYwJQjglAOZYRpBzLCFKOmQDlmACUYwJQjglAOSYA5ZgAlGMCUI45gpRjjiDlmAlQjglAOSYA5ZgAlGMCUI4JQDkhkkKnYo+G0WBXAOWYI0g5dgVQzn/nj80WNgoL5gAAAABJRU5ErkJggg==';

  public fileMaxSize = 5;
  readonly fileAcceptedTypes: string[] = [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/jpeg',
    'image/png',
  ];
  readonly imageAcceptedTypes: string[] = ['image/jpeg', 'image/png'];

  public formBid: FormGroup;

  public showAttachmentCreatedDate = false;

  constructor(
    public dialogRef: MatDialogRef<DialogUploadApplicationBidComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogUploadApplicationBidData,
    @Inject(DOCUMENT) private document: Document,
    private fb: FormBuilder,
    private readonly apiAnnotation: AnnotationApiService,
    private imageCompress: NgxImageCompressService,
    private domSanitizer: DomSanitizer,
    private readonly apiblob: BlobApiService,
    private readonly deviceService: DeviceDetectorService,
    private readonly dialogView: MatDialog
  ) {}

  ngOnInit() {
    this.initializeForm();
    this.initializeNaming();
  }

  private initializeForm(): void {
    this.formBid = this.fb.group({
      AttachmentName: ['', Validators.required],
      AttachmentCreatedDate: [new Date(), Validators.required],
      AttachmentUploadDate: [new Date(), Validators.required],
      estimatedCost: ['', Validators.min(1.0)],
      reasonForHigherBid: ['', Validators.pattern(/.*\S.*/)],
      selectThisBid: [false],
    });
  }

  private initializeNaming(): void {
    if (this.data.attachmentName.length) {
      this.formBid.get('AttachmentName')!.setValue(this.data.contractorName);
    }
    if (this.data.firstOrSecond === '1stBid' && this.data.estimatedCost > 0) {
      this.formBid.get('estimatedCost')!.setValue(this.data.estimatedCost);
    } else {
      if (
        (this.data.firstOrSecond === '2ndBid' ||
          this.data.firstOrSecond === '2ndBidEdit') &&
        this.data.estimatedCost2 > 0
      ) {
        this.formBid.get('estimatedCost')!.setValue(this.data.estimatedCost2);
      }
    }

    if (this.data.firstOrSecond === '1stBid') {
      if (
        this.data.isSelected === true ||
        (this.data.isSelected2 !== undefined && this.data.isSelected2 === false)
      ) {
        this.bidSelected = true;
        if (
          this.data.reasonRequired === true ||
          (this.data.reason && this.data.reason.length > 0)
        ) {
          this.higherBidSelected = true;
          if (this.data.reason && this.data.reason.length > 0) {
            this.formBid.get('reasonForHigherBid')!.setValue(this.data.reason);
          } else {
            if (this.data.reasonRequired === true) {
              setTimeout(() => {
                document.getElementById('reasonForHigherBid').focus();
              }, 1000);
            }
          }
        }
      } else {
        if (this.data.isSelected2 === undefined) {
          this.bidSelected = true;
          this.data.isSelected = true;
        } else {
          this.bidSelected = false;
        }
      }
    } else {
      if (
        (this.data.firstOrSecond === '2ndBid' ||
          this.data.firstOrSecond === '2ndBidEdit') &&
        this.data.isSelected2 === true
      ) {
        this.bidSelected = true;
        if (
          this.data.reasonRequired === true &&
          (this.data.reason2 === undefined ||
            this.data.reason2 === null ||
            this.data.reason2.length <= 0)
        ) {
          this.showReasonForSelectingHigherBid();
          setTimeout(() => {
            document.getElementById('reasonForHigherBid')!.focus();
          }, 1000);
        } else {
          if (
            this.data.reason2 !== undefined &&
            this.data.reason2 !== null &&
            this.data.reason2.length > 0
          ) {
            this.formBid.get('reasonForHigherBid')!.setValue(this.data.reason2);
            this.showReasonForSelectingHigherBid();
          }
        }
      } else {
        this.bidSelected = false;
      }
    }

    this.bidSelectedOriginal = this.bidSelected;
    this.estimatedCost2Original = this.data.estimatedCost2;

    // Do we already have a bid?
    if (this.data.payload !== null) {
      //console.log('appbid dialog payload not null');
      this.displayFileName = '';
      this.fileUploadLabel = 'REPLACE FILE';
      this.payloadName = this.data.payloadName;
      this.displayLink = 'true';
      this.disableFileSave = false;
      this.getSubmittedFile(this.data.payload, this.data.payloadName);
    } else {
      //console.log('appbid dialog payload is null');
      this.displayLink = 'false';
    }

    this.formBid.get('selectThisBid').setValue(this.bidSelected);
  }
  public getSubmittedFile(itemId: string, payloadName: string): void {
    if (itemId && itemId.length > 0) {
      this.apiblob.getTaskFiles(itemId, payloadName, 2).subscribe((res) => {
        this.createImageFromurl(itemId, res);
      });
    }
  }

  private updateReasonValidator(): void {
    const reasonControl = this.formBid.get('reasonForHigherBid');

    if (this.higherBidSelected) {
      reasonControl?.setValidators([
        Validators.required,
        Validators.pattern(/.*\S.*/),
      ]);
    } else {
      reasonControl?.clearValidators();
      reasonControl?.setErrors(null);
    }

    reasonControl?.updateValueAndValidity();
  }
  public createImageFromurl(itemId: string, fileBlob: Blob) {
    const reader = new FileReader();
    const fileGet: BidFile = {
      fileId: itemId,
      file: null,
      fileShow: false,
    };
    reader.addEventListener(
      'load',
      () => {
        fileGet.file = reader.result;
        fileGet.fileShow = true;
        this.filesToShow.push(fileGet);
        this.waitForFilesToShow--;
        this.fileId = itemId;
        this.payloadName = this.data.payloadName;
        const extension = this.data.payloadName.split('.').pop()?.toLowerCase();
        if (extension === 'pdf' || extension === 'docx') {
          this.displayFileUrl = this.attachmentBase64;
        } else {
          this.displayFileUrl = fileGet.file;
        }
      },
      false
    );

    reader.readAsDataURL(fileBlob);
  }
  public ebbFileInputChange(event: any) {
    this.disableFileSave = true;
    this.imageOrientation = -1;
    this.fileError = false;
    if (event.target.files.length > 0) {
      this.fileSelected = event.target.files[0];

      if (!this.isValidFileType(this.fileSelected)) {
        if (this.data.isImage) {
          this.displayFileName = `Only the following types of files can be uploaded: JPG, PNG.`;
          this.fileError = true;
        } else {
          this.displayFileName = `Only the following types of files can be uploaded: PDF, DOCX, JPG, PNG.`;
          this.fileError = true;
        }
        return;
      }

      if (!this.checkFileSize(this.fileSelected)) {
        this.displayFileName = `The Test file size must be less than ${this.fileMaxSize}MB`;
        this.fileError = true;
        return;
      }

      if (
        this.fileSelected.type === 'application/pdf' ||
        this.fileSelected.type ===
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ) {
        this.data.uploadFile = this.fileSelected;
        this.data.uploadFileName = this.fileSelected.name;
        this.displayFileName = `File: ${this.fileSelected.name}`;
        this.displayFileUrl = this.attachmentBase64;
      } else {
        this.displayFileName = this.fileSelected.name;
        this.data.uploadFileName = this.fileSelected.name;
        const reader = new FileReader();
        reader.onload = (event: any) => {
          this.fileLocalUrl = event.target.result;
          //this.imageCompressFile(this.fileLocalUrl,this.data.uploadFileName);
          this.imageCanvasResize(this.fileLocalUrl, 2000, 2000).then(
            (compressed) => {
              this.displayFileUrl = compressed;
              this.data.uploadFile = this.dataURItoBlob(
                this.displayFileUrl.split(',')[1]
              );
              this.disableFileSave = false;
              this.showRotateImage = true;
            }
          );
        };
        reader.readAsDataURL(event.target.files[0]);
      }

      this.displayLink = 'false';

      this.disableFileSave = false;
      const reason: string = this.formBid.get('reasonForHigherBid').value;

      if (
        this.formBid.get('estimatedCost').value > 0 &&
        (this.higherBidSelected === false ||
          (this.higherBidSelected === true && reason.length > 0))
      ) {
        this.disableSubmitBid = false;
      }
    } else {
      console.warn(`File not loaded.`);
    }
  }

  public imageCanvasResize(src, maxX, maxY) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');
        const maxWidth = maxX;
        const maxHeight = maxY;
        let ratio = 1;
        if (img.width < maxWidth && img.height < maxHeight) {
          const ratio = 1;
        } else {
          const ratioX = maxWidth / img.width;
          const ratioY = maxHeight / img.height;
          ratio = ratioX < ratioY ? ratioX : ratioY;
          //console.log(`comression ratio: ${ratio}`);
        }
        const finalWidth = img.width * ratio;
        const finalHeight = img.height * ratio;
        // console.log(`finalWidth: ${finalWidth}`);
        // console.log(`finalHeight: ${finalHeight}`);
        elem.width = Math.round(finalWidth);
        elem.height = Math.round(finalHeight);
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, finalWidth, finalHeight);
        const data = ctx.canvas.toDataURL();
        res(data);
      };
      img.onerror = (error) => {
        const message =
          error instanceof Error ? error.message : ' failed to load';
        rej(new Error(`load error: ${message}`));
      };
    });
  }

  public imageCompressFile(image, fileName) {
    const orientation = this.imageOrientation;
    this.imageCompress
      .compressFile(image, orientation, 50, 50)
      .then((result) => {
        this.displayFileUrl = result;
        this.data.uploadFile = this.dataURItoBlob(
          this.displayFileUrl.split(',')[1]
        );
        this.disableFileSave = false;
        this.showRotateImage = true;
      });
  }

  public rotateImageOrientation(): void {
    switch (this.imageOrientation) {
      case -1:
        this.imageOrientation = 6;
        this.rotateDegree = 90;
        this.imageCompressFile(this.fileLocalUrl, this.data.uploadFileName);
        break;
      case 6:
        this.imageOrientation = 3;
        this.rotateDegree = 180;
        this.imageCompressFile(this.fileLocalUrl, this.data.uploadFileName);
        break;
      case 3:
        this.imageOrientation = -1;
        this.rotateDegree = 90;
        this.imageCompressFile(this.fileLocalUrl, this.data.uploadFileName);
        break;
      default:
        this.imageOrientation = -1;
        this.rotateDegree = 90;
        this.imageCompressFile(this.fileLocalUrl, this.data.uploadFileName);
    }
  }

  public dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
  }

  public isValidFileType(file: Blob): boolean {
    let validType: boolean;
    if (this.data.isImage) {
      validType = this.imageAcceptedTypes.indexOf(file.type) > -1;
    } else {
      validType = this.fileAcceptedTypes.indexOf(file.type) > -1;
    }
    return validType;
  }

  public checkFileSize(file: Blob): boolean {
    let validSize = false;

    const fileSize: number = parseFloat((file.size / (1024 * 1024)).toFixed(3));

    Math.round(fileSize * 1000) > this.fileMaxSize * 1000
      ? (validSize = false)
      : (validSize = true);

    return validSize;
  }

  public onClickSelect(): void {
    this.bidSelected = this.formBid.get('selectThisBid')?.value;

    // Prevent deselection of contractor
    if (!this.bidSelected && this.bidSelectedOriginal) {
      this.bidSelected = true;
      this.formBid.get('selectThisBid')?.setValue(true);
      return;
    }

    this.data.isSelected =
      this.data.firstOrSecond === '1stBid' ? this.bidSelected : false;

    this.data.isSelected2 =
      this.data.firstOrSecond === '2ndBid' ||
      this.data.firstOrSecond === '2ndBidEdit'
        ? this.bidSelected
        : false;

    if (this.isHigherBidSelected()) {
      this.showReasonForSelectingHigherBid();
    } else {
      this.hideReasonForSelectingHigherBid();
    }

    this.updateReasonValidator();
  }
  private isHigherBidSelected(): boolean {
    if (
      this.bidSelected === true &&
      ((this.data.firstOrSecond === '1stBid' &&
        this.data.estimatedCost2 !== null &&
        this.data.estimatedCost2 > 0 &&
        this.data.estimatedCost > this.data.estimatedCost2) ||
        ((this.data.firstOrSecond === '2ndBid' ||
          (this.data.firstOrSecond === '2ndBidEdit' &&
            this.bidSelectedOriginal === false) ||
          (this.data.firstOrSecond === '2ndBidEdit' &&
            this.data.estimatedCost2 !== this.estimatedCost2Original)) &&
          this.data.estimatedCost2 > this.data.estimatedCost))
    ) {
      return true;
    } else {
      return false;
    }
  }

  private showReasonForSelectingHigherBid() {
    this.higherBidSelected = true;
    const reason: string = this.formBid.get('reasonForHigherBid').value;
    if (reason.length <= 0) {
      this.disableSubmitBid = true;
    }
  }

  private hideReasonForSelectingHigherBid() {
    this.higherBidSelected = false;

    const reasonControl = this.formBid.get('reasonForHigherBid');
    reasonControl?.clearValidators();
    reasonControl?.setErrors(null);
    reasonControl?.updateValueAndValidity();

    const fileExists = this.data.payloadName || this.data.uploadFile;
    // console.log('formBid.invalid', this.formBid.invalid);
    // console.log('estimatedCost', this.formBid.get('estimatedCost')?.value);
    // console.log('disableFileSave', this.disableFileSave);
    // console.log('fileExists', fileExists);
    // console.log('expression result',
    //   this.formBid.invalid ||
    //   this.formBid.get('estimatedCost')?.value <= 0 ||
    //   this.disableFileSave ||!fileExists

    // );
    this.disableSubmitBid =
      this.formBid.invalid ||
      this.formBid.get('estimatedCost')?.value <= 0 ||
      !fileExists;
  }
  public createImageFromBlob(annotationId: string, loadFile: IAnnotation) {
    const reader = new FileReader();

    const fileBlob = base64StringToBlob(
      loadFile.documentBody,
      loadFile.mimeType
    );

    const fileGet: BidFile = {
      fileId: annotationId,
      file: null,
      fileShow: false,
    };

    reader.addEventListener(
      'load',
      () => {
        fileGet.file = reader.result;
        fileGet.fileShow = true;
        this.filesToShow.push(fileGet);
        this.waitForFilesToShow--;
        this.fileId = annotationId;
        this.payloadName = this.data.payloadName;
        if (
          this.data.payloadName.substr(this.data.payloadName.length - 4, 4) ===
            '.pdf' ||
          this.data.payloadName.substr(this.data.payloadName.length - 4, 4) ===
            'docx'
        ) {
          this.displayFileUrl = this.attachmentBase64;
        } else {
          this.displayFileUrl = fileGet.file;
        }
      },
      false
    );

    reader.readAsDataURL(fileBlob);
  }

  public lookupSubmittedPhoto(itemId): BidFile {
    const result = this.filesToShow.find((i) => i.fileId === itemId);

    if (result) {
      return result;
    } else {
      const notFound: BidFile = {
        fileId: itemId,
        file: '../assets/images/imageNotFound.png',
        fileShow: true,
      };
      return notFound;
    }
  }

  public onClickCancel(): void {
    this.dialogRef.close();
  }

  public onEstimatedCostChangeEvent(event: any) {
    const value = Number(event.target.value);

    if (!value || value <= 1) {
      this.data.estimatedCost = value;
      this.disableSubmitBid = true;
    } else {
      if (this.data.firstOrSecond === '1stBid') {
        this.data.estimatedCost = value;
      } else {
        this.data.estimatedCost2 = value;
      }
    }

    if (
      this.isHigherBidSelected() &&
      (!this.data.reason || this.data.reason.length < 1)
    ) {
      this.showReasonForSelectingHigherBid();
    } else {
      this.hideReasonForSelectingHigherBid();
    }

    this.updateReasonValidator();
    const fileExists = this.data.payloadName || this.data.uploadFile;
    this.disableSubmitBid =
      this.formBid.invalid || value <= 1 || this.disableFileSave || !fileExists;
  }

  public onClickChangeContractor(): void {
    this.data.contractorId2 = 'CHANGE';
    this.dialogRef.close(this.data);
  }

  public onReasonChangeEvent(event) {
    const reason: string = event.target.value;
    if (
      reason.length <= 0 ||
      this.disableFileSave === true ||
      this.formBid.get('estimatedCost').value < 0 ||
      this.formBid.get('estimatedCost').value === ''
    ) {
      this.disableSubmitBid = true;
    } else {
      this.data.isSelected =
        this.data.firstOrSecond === '1stBid' ? this.bidSelected : false;
      this.data.isSelected2 =
        this.data.firstOrSecond === '2ndBid' ||
        this.data.firstOrSecond === '2ndBidEdit'
          ? this.bidSelected
          : false;
      this.data.reason = this.data.firstOrSecond === '1stBid' ? reason : '';
      this.data.reason2 =
        this.data.firstOrSecond === '2ndBid' ||
        this.data.firstOrSecond === '2ndBidEdit'
          ? reason
          : '';
      this.disableSubmitBid = false;
    }
  }
  public onViewFileEvent(payloadId: string, payloadName: string): void {
    console.log(`onViewFileEvent(${payloadId}, ${payloadName})`);
    const dialogViewDataItem: IDialogViewData = {} as IDialogViewData;

    if (!payloadId && payloadId.length === 0) {
      return;
    } else {
      if (this.onCheckToView(payloadName)) {
        //iOS does not allow open blob file in another tab
        if (this.deviceService.isMobile()) {
          dialogViewDataItem.annotationId = payloadId;
          dialogViewDataItem.viewType = 2;
          dialogViewDataItem.title = payloadName;
          const dialogRef = this.dialogView.open(DialogViewComponent, {
            maxWidth: '95vw',
            maxHeight: '85vh',
            height: '700px',
            width: '1000px',
            data: dialogViewDataItem,
          });
        } else {
          this.openImage(payloadId, payloadName);
        }
      } else {
        this.saveAsSubmittedFile(payloadId, payloadName);
      }
    }
  }
  private onCheckToView(payloadName: string): boolean {
    let retVal = false;
    if (payloadName && payloadName.length > 0) {
      const extension = payloadName.split('.').pop();
      switch (extension.toLowerCase()) {
        case 'jpg':
        case 'png':
          retVal = true;
          break;
        default:
          retVal = false;
      }
    }
    return retVal;
  }
  public openImage(payloadId: string, payloadName: string): void {
    this.apiblob.getTaskFiles(payloadId, payloadName, 2).subscribe(
      (fileBlob) => {
        // this.apiAnnotation.getAnnotation(payloadId).subscribe(
        //   data => {
        //     const fileBlob = base64StringToBlob(data.documentBody, data.mimeType);
        let navigator: any = window.navigator;
        if (navigator && navigator.msSaveOrOpenBlob) {
          navigator.msSaveOrOpenBlob(fileBlob, payloadName);
        } else {
          const linkToView = this.document.createElement('a');
          linkToView.href = window.URL.createObjectURL(fileBlob);
          linkToView.target = '_blank';
          linkToView.id = payloadName;
          document.body.appendChild(linkToView);
          linkToView.click();
          linkToView.remove();
        }
      },
      (error) => {
        console.warn(error);
      }
    );
  }
  private saveAsSubmittedFile(payloadId: string, payloadName: string): any {
    //  let fileBlob: Blob = null;

    if (payloadId && payloadId.length > 0) {
      this.apiblob.getTaskFiles(payloadId, payloadName, 2).subscribe(
        (fileBlob) => {
          let navigator: any = window.navigator;
          if (navigator && navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(fileBlob, payloadName);
          } else {
            const downloadLink = this.document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(fileBlob);
            downloadLink.download = payloadName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            downloadLink.remove();
          }
        },
        (error) => {
          console.warn(error);
        }
      );
    }
  }
  // public onViewFileEvent(annotationId: string): void {
  //   this.downloadFile(annotationId);
  // }

  public downloadFile(annotationId: string): void {
    this.apiAnnotation.getAnnotation(annotationId).subscribe(
      (annotation) => {
        const fileBlob = base64StringToBlob(
          annotation.documentBody,
          annotation.mimeType
        );
        const linkToView = this.document.createElement('a');
        linkToView.href = window.URL.createObjectURL(fileBlob);
        linkToView.target = '_blank';
        linkToView.id = this.data.payloadName;
        document.body.appendChild(linkToView);
        linkToView.click();
        linkToView.remove();
      },
      (error) => {
        console.warn(error);
      }
    );
  }
}
